export const DROPDOWN_WIDTH = {
  floatingBar: 28,
  drawer: 32,
};
